export default __webpack_public_path__ + "static/media/betterhelpLogo.4593a706.svg";